import { render, staticRenderFns } from "./principal_trabaja.vue?vue&type=template&id=031506e4&scoped=true"
import script from "./principal_trabaja.vue?vue&type=script&lang=js"
export * from "./principal_trabaja.vue?vue&type=script&lang=js"
import style0 from "./principal_trabaja.vue?vue&type=style&index=0&id=031506e4&prod&lang=css"
import style1 from "./principal_trabaja.vue?vue&type=style&index=1&id=031506e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031506e4",
  null
  
)

export default component.exports